import React, { PureComponent } from "react";
import PageNotFound from "components/page-not-found";
import Page from "components/page";
import { connect } from "react-redux";

class PageNotFoundPage extends PureComponent {
    render() {
        let featureDisabled = false;

        if (this.props.routes && this.props.routes.length) {
            featureDisabled = this.props.routes[this.props.routes.length - 1].featureIsDisabled;
        }

        return (
            <Page viewport={this.props.app.viewport} title="404" hasPageHeader={false}>
                <PageNotFound featureDisabled={featureDisabled} />
            </Page>
        );
    }
}

const mapStateToProps = (state) => ({
    app: state.app,
});

export default connect(mapStateToProps)(PageNotFoundPage);
